import ProjectInfo from "../components/project_details/ProjectHeader"
import PageContainer from "./PageContainer"
// import Speisen from '../assets/web/speisen.png'
import Social from '../assets/web/social.png'
import Team from '../assets/web/team.png' 
import Mut from '../assets/web/mut.png' 
import Info from "../components/project_details/Info"
import { useAnmeldeDaten } from "../hooks/useAnmeldeDaten"

const ChillyPage = () => {

    const anmeldeDaten = useAnmeldeDaten("CHILLY")
    // useEffect(()=>{
    //     window.scrollTo(0, 0);
    //     axios.get("http://localhost:1337/api/kontaktes?populate=*&filters[projekt][$eq]=CHILLY")
    //     .then((res) => {
    //         setAnmeldeDaten(res.data.data[0].attributes.anmeldedaten)
    //     })
    //     .catch((err) => console.log(err))
    //   },[])
      
    const project = {
        headline:'CHILLY NORD',
        info: 'CHILLY bietet einen Rahmen für Kinder und Jugendliche, um sich in einer Gruppe zu treffen und gemeinsam eine chillige Zeit zu verbringen.',
        image: 'chilly.jpg'
    }

    return(
        <PageContainer>
            <div className="flex flex-col gap-8 md:gap-8 lg:gap-12 xl:gap-24">
            <ProjectInfo project={project}/>
            <div className="flex flex-col w-full gap-10 items-center md:items-start">
                <div className="text-2xl lg:text-3xl xl:text-5xl font-semibold pt-6">Worum geht's?</div>
                <div className="flex flex-col md:grid md:grid-cols-2 md:grid-rows-1 gap-x-8 xl:gap-y-24 md:gap-y-12 gap-y-8">
                    <Info text={<span>Förderung des <span className="font-semibold">Gemeinschaftssinnes</span> und der <span className="font-semibold">Teamfähigkeit</span> durch unterschiedliche Aktivitäten.</span>} icon={Team}/>
                    <Info text={<span>Zuwachs an realem und sozialem Austausch durch Kennenlernen <span className="font-semibold">neuer Freunde</span>.</span>} icon={Social}/>
                    <Info text={<span><span className="font-semibold">Mut zum Ausprobieren, Kreativität</span> und <span className="font-semibold">Selbstwirksamkeit</span> werden gestärkt.</span>} icon={Mut}/>
                </div>
                <div className="flex md:flex-row flex-col w-full text-center md:text-left gap-32 pt-8 md:pt-10 pb-12">
                    <div className="flex flex-col w-full md:w-1/2 gap-4">
                        <div className="text-xl lg:text-2xl xl:text-4xl font-semibold">Wo und wann findest du uns?</div>
                        <div className="text-md lg:text-lg xl:text-2xl"><span>alternierend</span>
                        <br /><br/>
                        <span>
                            dienstags Pfarrhof Friedberg von 14:30-17:30
                            <br />
                            <br />
                            mittwochs MS Waldbach von 14:30-17:30
                        </span>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <div className="text-xl lg:text-2xl xl:text-4xl font-semibold">Anmeldung:</div>
                        <div className="w-full flex flex-col text-md lg:text-lg xl:text-2xl gap-8">
                            <div className="flex flex-col gap-6">
                                {
                                    anmeldeDaten.map((data) => {
                                        return(
                                            <div className="flex flex-col gap-2">
                                                <div>{data.name}</div>
                                                <div>{data.telefonnummer}</div>
                                                <div>{data.email}</div>
                                                <div>{data.text}</div>
                                            </div>
                                        )
                                    })
                                }

                                {/* <div>Astrid Kirchsteiger</div>
                                <div>0664/88 239 642</div>
                                <div className="text-nowrap">astrid.kirchsteiger@sdhf.at</div>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div>Waltraud Amesbauer-Fabsits</div>
                                <div>0664/88 239 639</div>
                                <div>waltraud.amesbauer-fabsits@sdhf.at</div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>

        </PageContainer>
    )
}

export default ChillyPage